export default __webpack_public_path__ + "static/media/icone-diretoria.91efa0e9.png";